import { getFollowingUsers } from "@/services";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";

import UserList from "../../components/UserList";

import styles from "./index.module.less";

export default function SearchFollowingUserList({ query, empty }) {
  const pageRef = useRef(1);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);

  const { q, urlname } = query;

  const queryAction = useMemo(() => {
    pageRef.current = 1;
    setDataSource([]);
    setHasMore(true);

    return async () => {
      if (!q || !urlname) {
        return;
      }

      const limit = 20;

      const result = await getFollowingUsers({
        q,
        urlname,
        limit,
        page: pageRef.current,
      });

      const users = result?.users || [];

      if (users.length <= 0) {
        setHasMore(false);
      }

      setDataSource((dataSource) => dataSource.concat(users));
      setTotal(result?.total || 0);
    };
  }, [q, urlname]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  return (
    <div className={styles.tab}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          {total > 0 && (
            <div className={styles.info}>
              找到 {total} 个与 <span className={styles.searchKey}>{q}</span>{" "}
              相关的用户
            </div>
          )}
          <UserList
            type="primary"
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
